






































































import {
  defineComponent,
  ref,
  computed,
  onMounted,
  PropType,
  inject,
} from 'vue';
import dayjs from 'dayjs';
import { env } from '@hb/mbridge';
import { UBT } from '@hb/tianqi/lib/ubt.h5';
import { uiMgr } from '~mall/common/uiMgr';
import { goTwoWheelCardPage, showThirdPageOld } from '~mall/common/utils/jumpUrl';
import { setParamsToUrl } from '~mall/common/utils/params';
import { timePad } from '~mall/common/utils/time';
import NativeMgr from '~mall/common/native/native';
import {
  actionRePay,
  reqMultiGoodsRepay,
} from '~mall/model/apis/order';
import type { OrderListItem } from '~mall/model/store/modules/order';
import type { PayOrderInfo, SkuDetailData, SignPayInfoType } from '~mall/model/store/modules/ticket';
import {
  OrderStatus,
  OrderStatusText,
  OrderStatusImg,
} from '../../consts/index';
import { reqOrderPay } from '~mall/model/apis/bike';
import { getCouponMallOrderListUrl } from '~mall/model/utils';
import {
  payWithSignNew,
  checkPayWithSignVersionCompatibility,
  PaymentType,
  getPaymentTypeByPayInfo,
} from '~mall/model/apis/pay';
import { safeJsonParse } from '~mall/common/utils';

export default defineComponent({
  name: 'OrderCell',
  props: {
    order: {
      type: Object as PropType<OrderListItem>,
      required: true,
      default: () => ({}),
    },
  },
  emits: ['reload'],
  setup(props, { emit }) {
    // Reactive data
    const timerId = ref(0);
    const timeLeft = ref(0);
    const showWaitPayBtn = ref(false);
    const imageUrl = ref('');
    const styleVersion = inject('styleVersion');

    // Computed properties
    /** 已退款和已过期的订单 */
    const finished = computed(() => {
      const { orderStatus } = props.order;
      return ([
        OrderStatus.REFUND,
        OrderStatus.OUTDATE,
      ] as number[]).includes(orderStatus);
    });

    const orderDate = computed(() => {
      const { orderTime } = props.order;
      return dayjs(orderTime).format('YYYY.MM.DD HH:mm:ss');
    });

    const statusImgSrc = computed(() => OrderStatusImg[props.order.orderStatus]);

    /** 拼团数据 */
    const group = computed(() => props.order.goodsList
      .find(({
        priceType,
        groupRecordInfo,
      }: any) => (priceType === 2 && groupRecordInfo))
      ?.groupRecordInfo);

    const orderShow = computed(() => {
      if (group.value) {
        const {
          itemAliasName,
          originPrice,
          groupPrice,
        } = group.value;
        return {
          goodsNameShow: itemAliasName,
          originalPriceShow: originPrice,
          salePriceShow: groupPrice,
          ...props.order,
        };
      }

      const {
        showGoodsName,
        totalOriginalPrice,
        payPrice,
      } = props.order;
      return {
        goodsNameShow: showGoodsName,
        originalPriceShow: totalOriginalPrice,
        salePriceShow: payPrice,
        ...props.order,
      };
    });

    const statusShow = computed(() => {
      if (group.value) {
        const { groupStatus } = group.value;
        const { orderStatus } = props.order;
        let groupStatusText = '';

        if (
          groupStatus === 0
          && orderStatus !== OrderStatus.PAY
        ) {
          groupStatusText = '待成团';
        } else if (groupStatus === 1) {
          groupStatusText = '团成功';
        } else if (groupStatus === 2) {
          groupStatusText = '团失败';
        }

        return `${groupStatusText} ${OrderStatusText[orderStatus]}`;
      }

      return '';
    });

    const grouponRemainShow = computed(() => {
      if (!group.value) {
        return '';
      }

      const {
        groupStatus,
      } = group.value;

      if (groupStatus === 0 && props.order.orderStatus !== OrderStatus.PAY) {
        const {
          expiredTime,
          groupNum,
          joinedNum,
        } = group.value;
        const remain = new Date(expiredTime).getTime() - new Date().getTime();
        const people = groupNum - joinedNum;
        const allMin = Math.floor(remain / 1000 / 60);
        const hour = Math.floor(allMin / 60);
        const min = Math.floor(allMin - hour * 60);

        let remainTime = '';
        if (hour && hour > 0) {
          remainTime += `${hour}小时`;
        }
        if (min && min > 0) {
          remainTime += `${min}分钟`;
        }
        return `还差${people}人(${remainTime}后结束)`;
      }

      return '';
    });

    const sharedUbtBizInfo = computed(() => {
      const {
        goodsList,
        orderStatus,
        orderId,
      } = props.order;
      return {
        businessType: goodsList.map(({ categoryId }: any) => categoryId).join(','),
        order_status: orderStatus,
        orderId,
        experimentalGroup: styleVersion,
      };
    });

    const listPic = computed(() => (imageUrl.value
      || props.order.goodsList?.[0]?.listPicUrl
      || 'https://m.hellobike.com/helloyun3/34292/ft4r0k5i_doudi.png'));

    const formattedTimer = computed(() => {
      if (timeLeft.value <= 0) {
        return '';
      }

      const minuteMillis = timeLeft.value % 864e5 % 36e5;
      const minutes = Math.floor(minuteMillis / 6e4);
      const seconds = Math.floor((minuteMillis % 6e4) / 1000);
      return `${timePad(minutes)}:${timePad(seconds)}`;
    });

    // Methods
    const getActivityUrl = () => {
      if (group.value?.activityUrl) {
        let { activityUrl: url } = group.value;
        const { groupGuid } = group.value;

        if (groupGuid && url.indexOf('?') > 0) {
          url += `&groupGuid=${groupGuid}`;
        } else {
          url += `?groupGuid=${groupGuid}`;
        }

        return setParamsToUrl(
          {
            adsource: 'supermall',
            remark: '卡券',
          },
          url,
        );
      }

      return '';
    };

    const goDetail = () => {
      const {
        orderId,
        goodsList,
        showGoodsName,
      } = props.order;
      // 点击埋点
      UBT.clickButton({
        pageId: 'platform_couponMall_orderList',
        buttonName: 'platform_couponMall_order_click',
        categoryId: 'platform',
        businessInfo: sharedUbtBizInfo.value,
      });

      if (props.order.isTwoWheelCard) {
        goTwoWheelCardPage();
        return;
      }

      if (props.order.priceType !== 2) {
        uiMgr.pushPage(`/order/${orderId}`);
      } else {
        const url = getActivityUrl();
        if (url) {
          showThirdPageOld(url);
        }
      }
    };

    const payOrder = async (e: MouseEvent) => {
      e.stopPropagation();
      const {
        goodsList,
        showGoodsName,
        payOrder: payOrderData,
        orderStatus,
        isTwoWheelCard,
      } = props.order;
      UBT.clickButton({
        pageId: 'mkt_couponmall_orderlist',
        buttonName: 'mkt_couponmall_orderlist_order',
        categoryId: 'market',
        businessInfo: {
          coupon_itemid: goodsList.map(({ spuId }: any) => spuId).join(','),
          itemname: showGoodsName,
          order_status: OrderStatusText[orderStatus],
        },
      });
      const { version } = await NativeMgr.getDeviceInfo();
      const payInfo = safeJsonParse<SignPayInfoType>(
        props.order?.extra?.payInfo,
        {} as SignPayInfoType,
      );
      const paymentType = getPaymentTypeByPayInfo(payInfo);

      // const monthlyScene = this.order?.extra?.COUPON_MONTHLY_SCENE;
      // const passwordScene = this.order?.extra?.PASSWORD_SCENE;
      // const isDyCard = monthlyScene === COUPON_MONTHLY_SCENE.DOUYIN_MONTHLY_PROPERTY;
      // const isAlipayMonthly = monthlyScene === COUPON_MONTHLY_SCENE.ALIPAY_MONTHLY_PROPERTY;
      // const isDouyinPassword = passwordScene === PASSWORD_SCENE.DOUYIN_PASSWORD_PROPERTY;
      // const isPayWithSignGoods = isDyCard || isDouyinPassword || isAlipayMonthly;

      // 支付宝渠道支持 App 和支付宝小程序，抖音渠道只支持 App
      // 版本检查只在 App 环境下进行
      let shouldShowPayWithSign = false;
      // !! 如果paymentType新增类型和普通商品一样不走签约要处理这里增加判断条件
      if (paymentType !== PaymentType.NORMAL) {
        if (paymentType === PaymentType.ALIPAY_MONTHLY) {
          // 支付宝：App 需要版本检查，支付宝小程序不需要
          shouldShowPayWithSign = env.isEasyBikeApp
            ? checkPayWithSignVersionCompatibility(version)
            : env.isAliMP;
        } else {
          // 抖音：只支持 App 且需要版本检查
          shouldShowPayWithSign = env.isEasyBikeApp
            && checkPayWithSignVersionCompatibility(version);
        }
      }

      if (shouldShowPayWithSign) {
        // 根据 extra 字段确定支付类型
        // let paymentType: PaymentType;
        // if (isDyCard) {
        //   paymentType = PaymentType.DOUYIN_MONTHLY;
        // } else if (isDouyinPassword) {
        //   paymentType = PaymentType.DOUYIN_PASSWORD_FREE;
        // } else if (isAlipayMonthly) {
        //   paymentType = PaymentType.ALIPAY_MONTHLY;
        // } else {
        //   paymentType = PaymentType.NORMAL;
        // }
        payWithSignNew({
          ...props.order?.goodsList[0],
          payInfo,
          _priceInfo: {
            realPrice: orderShow.value.salePriceShow,
          },
        } as unknown as SkuDetailData & {
          _priceInfo: { realPrice: number };
        });
        return;
      }

      if (isTwoWheelCard) {
        const {
          payMoney,
          payOrderId,
          businessType,
          businessScene,
          billNo,
        } = payOrderData;
        await reqOrderPay({
          orderGoPayList: [{
            payNo: payOrderId,
            orderNo: billNo,
            businessType,
            payPrice: payMoney,
          }],
          businessType,
          businessScene,
          returnUrl: getCouponMallOrderListUrl(),
        });
        emit('reload');
        return;
      }

      const payOrderInfo: PayOrderInfo = payOrderData;
      const goodsLen = goodsList.length;

      if (goodsLen === 0) {
        return;
      }

      // 单商品订单重新支付
      if (goodsLen === 1) {
        const [firstOrder] = goodsList;
        const {
          categoryId,
          orderSource,
        } = firstOrder;

        if (group.value) {
          actionRePay({
            info: {
              payOrderInfo,
              categoryId,
              orderSource,
              activityCode: group.value.activityCode,
              activityUrl: getActivityUrl(),
              skuData: firstOrder,
            },
            isPushPage: true,
            successCallback: () => {
              emit('reload');
            },
          });
        } else {
          actionRePay({
            info: {
              payOrderInfo,
              categoryId,
              skuData: firstOrder,
            },
            isPushPage: true,
            successCallback: () => {
              emit('reload');
            },
          });
        }
        return;
      }
      reqMultiGoodsRepay(props.order);
    };

    const setShowWaitPayBtn = async () => {
      const { version } = await NativeMgr.getDeviceInfo();
      const waitPayStatus = props.order.orderStatus === 0;
      const waitPaySource = !props.order.orderSource || props.order.orderSource === 3;
      const payInfo = safeJsonParse<SignPayInfoType>(
        props.order?.extra?.payInfo,
      {} as SignPayInfoType,
      );
      const paymentType = getPaymentTypeByPayInfo(payInfo);
      // const monthlyScene = this.order?.extra?.COUPON_MONTHLY_SCENE;
      // const passwordScene = this.order?.extra?.PASSWORD_SCENE;

      // const isDyCard = monthlyScene === COUPON_MONTHLY_SCENE.DOUYIN_MONTHLY_PROPERTY;
      // const isAlipayMonthly = monthlyScene === COUPON_MONTHLY_SCENE.ALIPAY_MONTHLY_PROPERTY;
      // const isDouyinPassword = passwordScene === PASSWORD_SCENE.DOUYIN_PASSWORD_PROPERTY;
      // const isPayWithSignGoods = isDyCard || isDouyinPassword || isAlipayMonthly;

      // !! 如果paymentType新增类型和普通商品一样不走签约要处理这里增加判断条件
      if (paymentType !== PaymentType.NORMAL) {
        // 支付宝渠道支持 App 和支付宝小程序，抖音渠道只支持 App
        // 版本检查只在 App 环境下进行
        let shouldShowPayBtn = false;
        if (paymentType === PaymentType.ALIPAY_MONTHLY) {
          // 支付宝：App 需要版本检查，支付宝小程序不需要
          shouldShowPayBtn = env.isEasyBikeApp
            ? checkPayWithSignVersionCompatibility(version)
            : env.isAliMP;
        } else {
          // 抖音：只支持 App 且需要版本检查
          shouldShowPayBtn = env.isEasyBikeApp && checkPayWithSignVersionCompatibility(version);
        }
        showWaitPayBtn.value = waitPayStatus && waitPaySource && shouldShowPayBtn;
      } else {
        showWaitPayBtn.value = waitPayStatus && waitPaySource;
      }
    };

    const handleImageError = () => {
      imageUrl.value = 'https://m.hellobike.com/helloyun3/34292/ft4r0k5i_doudi.png';
    };

    const teardownTimer = () => {
      window.clearTimeout(timerId.value);
      timerId.value = 0;
    };

    const startTimer = (end: number): number => window.setTimeout(() => {
      const now = Date.now();

      if (now >= end) {
        timeLeft.value = 0;
        teardownTimer();
        window.location.reload();
      } else {
        timeLeft.value = end - now;
        timerId.value = startTimer(end);
      }
    }, 1000);

    const setupTimer = () => {
      const {
        deadlineTime: timeStr,
      } = props.order || {};

      if (timeStr) {
        const time = dayjs(timeStr).valueOf();
        timeLeft.value = Math.max(time - Date.now(), 0);

        if (timeLeft.value) {
          timerId.value = startTimer(time);
        }
      }
    };

    // Lifecycle
    onMounted(async () => {
      // 卡片曝光埋点
      UBT.moduleExpose({
        pageId: 'platform_couponMall_orderList',
        categoryId: 'platform',
        moduleId: 'platform_couponMall_order_expose',
        contentId: 'platform_couponMall_order_expose',
        exposureTimes: 1,
        businessInfo: sharedUbtBizInfo.value,
      });
      await setShowWaitPayBtn();
      setupTimer();
    });

    return {
      finished,
      orderDate,
      statusImgSrc,
      group,
      orderShow,
      statusShow,
      grouponRemainShow,
      sharedUbtBizInfo,
      listPic,
      formattedTimer,
      showWaitPayBtn,
      goDetail,
      payOrder,
      handleImageError,
    };
  },
});
